import { render, staticRenderFns } from "./selectPersonAndRole.vue?vue&type=template&id=6ae97e9e"
import script from "./selectPersonAndRole.vue?vue&type=script&lang=js"
export * from "./selectPersonAndRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports